export { default as EmojiVeryHappyFill } from './EmojiVeryHappyFill'

export { default as HappyFill } from './HappyFill'

export { default as UnhappyFill } from './UnhappyFill'
